import React from 'react';

import '../../styles/components/options/editButton.scss';
import doneBtn from '../../assets/done.svg';
import editBtn from '../../assets/edit_pencil.svg';

export default function EditButtonTwo({ editState, handleEditStateTwo }) {
	return (
		<div className='edit_button_wrapper' onClick={() => handleEditStateTwo()}>
			<div className='edit_button_container'>
				<img src={editState ? doneBtn : editBtn} alt='' />
			</div>
		</div>
	);
}
